import script from "./main.widget.vue?vue&type=script&lang=ts&setup=true"
export * from "./main.widget.vue?vue&type=script&lang=ts&setup=true"

import "./main.widget.vue?vue&type=style&index=0&id=7dd70ecc&lang=scss"

const __exports__ = script;

export default __exports__